/*
 * @format
 */

import * as types from '../action-types';

export const resumeRegistration = () => ({
  type: types.RESUME_REGISTRATION_START,
});

export const resumeRegistrationAbort = () => ({
  type: types.RESUME_REGISTRATION_ABORT,
});

export const resumeRegistrationWithDeviceDetails = (
  macAddress,
  publicKey,
  connectionValidAfter,
) => ({
  type: types.RESUME_REGISTRATION_RETURN_TO_APP,
  macAddress,
  publicKey,
  connectionValidAfter,
});
